import { httpClient } from '@/shared/services';
import type { Configuration, ExecutionResult, IndexadoPreview, Pair, PreviewResult, Selection } from './types';
import { optionsOnly, previewRequest } from './utils';

export const consolidationService = {
  async previewIndexados(configuration: Configuration, selection: Selection): Promise<IndexadoPreview[]> {
    const response = await httpClient.post<{ indexados: IndexadoPreview[] }>(
      '/v1/sku-unification/preview-indexados', { ...optionsOnly(configuration), selection },
    );
    return response.data.indexados;
  },
  async preview(configuration: Configuration, pair: Pair): Promise<PreviewResult> {
    const response = await httpClient.post<{ results: PreviewResult[] }>(
      '/v1/sku-unification/preview', previewRequest(configuration, pair),
    );
    if (!response.data.results?.[0]) throw new Error('La previsualización no devolvió un resultado para esta fila.');
    return response.data.results[0];
  },
  async execute(configuration: Configuration, selection: Selection): Promise<ExecutionResult> {
    const response = await httpClient.post<{ results: ExecutionResult[] }>(
      '/v1/sku-unification/execute', { ...optionsOnly(configuration), items: [selection] },
    );
    if (!response.data.results?.[0]) throw new Error('La ejecución no devolvió un resultado confirmado para esta fila.');
    return response.data.results[0];
  },
};
